<template>
  <div class="hubday-section">
    <div class="hubday-head">
      <i class="material-icons-outlined">folder</i>Ressources de classe
    </div>
    <div class="hubday-body resources">
      <div
        v-if="
          userProfile.permissions && userProfile.permissions.includes('guest')
        "
        class="noItem"
      >
        <i class="material-icons-outlined">folder</i>Vous devez être connecté
        <br />pour afficher les ressources !
      </div>
      <div v-else-if="files == null" class="noItem">
        <i class="material-icons-outlined">folder</i>Pas de ressource à afficher
      </div>
      <div v-else>
        <transition name="fade" mode="out-in">
          <div v-html="files" v-bind:key="files"></div>
        </transition>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <div
        v-if="
          userProfile.permissions && userProfile.permissions.includes('student')
        "
        class="hubday-footer"
        v-bind:key="lastUpdate"
      >
        {{ lastUpdate }}
      </div>
    </transition>
  </div>
</template>

<style scoped>
.noItem {
  min-height: 224px;
}
</style>

<style>
#resources ul#folders,
ul#folders ul {
  list-style-type: none;
  padding-left: 26px;
}

#resources ul#folders {
  margin: 0;
  padding: 0;
}

#resources .folder {
  cursor: pointer;
  user-select: none;
}

#resources span + a {
  color: #aaa;
  vertical-align: -9%;
}

#resources .folder i::before,
#resources .file::before {
  content: "\e912";
  font-family: "icomoon" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-right: 6px;
  font-size: 22px;
  vertical-align: -15%;
}

#resources .file::before {
  font-size: 18px;
  margin: 0 8px 0 2px;
  content: "\e90c";
}

#resources .file.void {
  color: #888;
}
#resources [data-type="folder"]::before {
  content: "\e912";
}
#resources [data-type="presentation"]::before {
  content: "\e906";
}
#resources [data-type="spreadsheet"]::before {
  content: "\e907";
}
#resources [data-type="document"]::before {
  content: "\e908";
}
#resources [data-type="image"]::before {
  content: "\e910";
}
#resources [data-type="zip"]::before {
  content: "\e902";
}
#resources [data-type="video"]::before {
  content: "\e903";
}
#resources [data-type="audio"]::before {
  content: "\e904";
}
#resources [data-type="text"]::before {
  content: "\e90a";
}
#resources [data-type="pdf"]::before {
  content: "\e90f";
}
#resources [data-type="code"]::before {
  content: "\e901";
}

#resources .link::before {
  content: "\e948";
  font-size: 22px;
  margin: 0 6px 0 -2px;
}

#resources .folder-open i::before {
  content: "\e911";
}

#resources .nested {
  list-style-type: none;
  padding-left: 12px;
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
}

#resources .active {
  max-height: 700px;
  transition: max-height 0.5s ease-in;
}

#resources ul li .file a,
#resources ul ul li .file a {
  border-bottom: 1px dotted #999;
}

.hubday-body.resources {
  padding-bottom: 0;
}

.hubday-body.resources h2 {
  border-bottom: 1px solid #eee;
}

.hubday-body.resources .smaller a {
  color: #888;
  transition: color 0.3s;
}

.hubday-body.resources .smaller a:hover {
  color: #000;
  border-bottom: 1px dotted #888;
}

.hubday-body.resources .smaller i {
  font-size: 16px;
  vertical-align: -15%;
}
</style>

<script>
import { mapState } from "vuex";

import * as firebase from "firebase/app";
import "firebase/database";
const rtdb = firebase.database();

export default {
  data() {
    return {
      files: null,
      lastUpdate: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "modules", "modulesByAlias"]),
  },
  watch: {
    userProfile() {
      this.loadFiles();
    },
  },
  methods: {
    moduleColor(moduleName) {
      if (Object.keys(this.modulesByAlias).includes(this.htmlEntitiesReverse(moduleName))) {
        return this.modules[this.modulesByAlias[this.htmlEntitiesReverse(moduleName)]].color;
      } else {
        return "black";
      }
    },
    moduleIcon(moduleName) {
      if (Object.keys(this.modulesByAlias).includes(moduleName)) {
        return this.modules[this.modulesByAlias[moduleName]].icon;
      } else {
        return "default";
      }
    },
    htmlEntitiesReverse(str) {
      return String(str)
        .replace("&amp;", "&")
        .replace("&lt;", "<")
        .replace("&gt;", ">")
        .replace("&quot;", "\"");
    },
    loadFiles() {
      if (
        this.userProfile.permissions &&
        this.userProfile.permissions.includes("student")
      ) {
        var self = this;
        var filesRef = rtdb.ref("files/" + this.userProfile["group2"]);
        filesRef.on("value", function (snapshot) {
          var data = snapshot.val();
          self.displayFolders(data);
        });
      }
    },
    convertDate(inputFormat) {
      var d = new Date(inputFormat);
      return (
        /*[
          this.pad(d.getDate()),
          this.pad(d.getMonth() + 1),
          d.getFullYear(),
        ].join("/") +*/
        d.getHours() + "h" + this.pad(d.getMinutes())
      );
    },
    pad(s) {
      return s < 10 ? "0" + s : s;
    },
    displayFolders(data) {
      var foldersContainerText = "";
      var group = data["--name"];
      var folderContent = data;
      foldersContainerText += `<h2>
        <div>
          <div>${group}</div>
          <div class="smaller"><a href="${
            "https://drive.google.com/drive/folders/" + folderContent["--id"]
          }" target="_blank">Ouvrir le dossier <i class="material-icons-outlined">open_in_new</i></a></div>
        </div>
        <div class="controls">
          <button onClick="document.querySelectorAll('li .nested').forEach(v => v.classList.remove('active')); document.querySelectorAll('li > .folder').forEach(v => v.classList.remove('folder-open'));">
            <i class="material-icons">expand_less</i>
          </button><button onClick="document.querySelectorAll('li:not(.empty) > .nested').forEach(v => v.classList.add('active')); document.querySelectorAll('li:not(.empty) > .folder').forEach(v => v.classList.add('folder-open'));">
            <i class="material-icons">expand_more</i>
          </button>
        </div>
      </h2>`;
      this.lastUpdate =
        "Dernière mise à jour à " +
        this.convertDate(folderContent["--lastUpdate"]);
      foldersContainerText += '<ul id="' + folderContent["--id"] + '">';
      foldersContainerText += this.constructFolder(
        folderContent,
        folderContent["--id"],
        true
      );
      foldersContainerText += "</ul>";
      //}

      this.files = foldersContainerText;
    },
    constructFolder(folder, id, root = false) {
      var cleaner = document.createElement("div");
      cleaner.innerText = folder["--name"];
      folder["--name"] = cleaner.innerHTML;

      var html = "";

      var folderList = [];
      var fileList = [];

      if (!root)
        html += `<li data-name="${folder["--name"]}" id="${id}"${
          Object.entries(folder).filter((v) => !v[0].startsWith("--")).length ==
          0
            ? " class='empty'"
            : ""
        }>
                            <span class="folder${
                              folder["--name"].startsWith("M")
                                ? " " + folder["--name"].split(" ")[0]
                                : ""
                            }" onClick="if (window.event.ctrlKey) { console.log(this.parentElement.id) } else { this.parentElement.querySelector('.nested').classList.toggle('active'); this.classList.toggle('folder-open');} "><i class="icon-folder" ${
          "style='color: " + this.moduleColor(folder["--name"]) + ";'"
        }></i> ${folder["--name"]}</span>
                            <a href="https://drive.google.com/drive/folders/${id}" target="_blank"><i class="icon-open_in_new"></i></a>
                            <ul class="browser-default nested">`;
      for (const [id, content] of Object.entries(folder)) {
        if (!id.startsWith("--")) {
          if (content["--type"] == "folder")
            folderList.push(this.constructFolder(content, id, false));
          else fileList.push(this.constructFile(content, id));
        }
      }
      html += folderList
        .sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        })
        .join("");
      html += fileList
        .sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        })
        .join("");

      if (fileList.length + folderList.length == 0)
        if (root)
          html += `<div class="noItem inline"><i class="material-icons-outlined">insert_drive_file</i>Pas de documents pour l'instant</div>`;
        else html += `<li><span class="file void">Aucun contenu</span></li>`;

      if (!root) html += "</ul></li>";

      return html;
    },
    constructFile(file, id) {
      return `<li data-name="${file["--name"]} "id=${id}>
                <span class="file" data-type="${file["--type"]}">
                    <a href="${
                      file["--url"]
                        ? file["--url"]
                        : "https://drive.google.com/file/d/" + id + "/view"
                    }" target="_blank">
                        ${file["--name"]}
                    </a>
                </span>
                ${
                  file["--download"]
                    ? file["--download"] == true
                      ? '<a href="https://drive.google.com/uc?id=' +
                        id +
                        '&export=download" target="_blank"><i class="icon-download"></i></a>'
                      : '<a href="' +
                        file["--download"] +
                        '" target="_blank"><i class="icon-download"></i></a>'
                    : ""
                }
            </li>`;
    },
  },
  mounted() {
    this.loadFiles();
  },
};
</script>